export default __webpack_public_path__ + "static/media/neymarProfile.171e5244.png";